import dayjs from 'dayjs';
import { IProduct } from 'app/shared/model/product.model';
import { ProcessType } from 'app/shared/model/enumerations/process-type.model';
import { StepType } from 'app/shared/model/enumerations/step-type.model';
import { StepStatus } from 'app/shared/model/enumerations/step-status.model';

export interface IProductProcess {
  id?: number;
  processType?: keyof typeof ProcessType;
  stepType?: keyof typeof StepType;
  stepStatus?: keyof typeof StepStatus;
  retryCount?: number | null;
  payloadIn?: string | null;
  payloadOut?: string | null;
  coolingOffEnd?: dayjs.Dayjs | null;
  offerExpirationDate?: dayjs.Dayjs | null;
  mandateSignedDate?: dayjs.Dayjs | null;
  desiredDate?: dayjs.Dayjs | null;
  actualStartDate?: dayjs.Dayjs | null;
  transactionId?: string | null;
  waiveCoolingOffRight?: boolean | null;
  depositRequired?: boolean | null;
  deposit?: boolean | null;
  createdAt?: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs;
  product?: IProduct | null;
}

export const defaultValue: Readonly<IProductProcess> = {
  waiveCoolingOffRight: false,
  depositRequired: false,
  deposit: false,
};
